(function() { window.GUID_570f40a5_e749_465e_8e0e_81c6c11a47ad = { getGuid: function() { return "570f40a5-e749-465e-8e0e-81c6c11a47ad"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let EventsLinkerValidationErrorCode;
        (function (EventsLinkerValidationErrorCode) {
            EventsLinkerValidationErrorCode[EventsLinkerValidationErrorCode["SomeFirstNamesDontMatch"] = 1] = "SomeFirstNamesDontMatch";
            EventsLinkerValidationErrorCode[EventsLinkerValidationErrorCode["SomeLastNamesDontMatch"] = 2] = "SomeLastNamesDontMatch";
            EventsLinkerValidationErrorCode[EventsLinkerValidationErrorCode["SomeNamesDontMatch"] = 3] = "SomeNamesDontMatch";
            EventsLinkerValidationErrorCode[EventsLinkerValidationErrorCode["AllFirstNamesDontMatch"] = 4] = "AllFirstNamesDontMatch";
            EventsLinkerValidationErrorCode[EventsLinkerValidationErrorCode["AllLastNamesDontMatch"] = 5] = "AllLastNamesDontMatch";
            EventsLinkerValidationErrorCode[EventsLinkerValidationErrorCode["AllNamesDontMatch"] = 6] = "AllNamesDontMatch";
            EventsLinkerValidationErrorCode[EventsLinkerValidationErrorCode["CantLinkToThatPlayer"] = 7] = "CantLinkToThatPlayer";
        })(EventsLinkerValidationErrorCode = Enumeration.EventsLinkerValidationErrorCode || (Enumeration.EventsLinkerValidationErrorCode = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=EventsLinkerValidationErrorCode.pre.js.map
